import FormButton from "../Components/Buttons/FormButton";

const PrintPackSlipLayout = ({ handleClose }: { handleClose: () => void }) => {
    const handleSubmit = () => {
        handleClose();
    };

    return (

        <form onSubmit={handleSubmit} className="form">
            <div className="d-flex justify-content-center">
                <div className="col-12 col-md-12 col-lg-12 mt-2">
                    <div className="row">
                        <div className="col">
                            <div className="px-2">
                                <label className="label-light-grey fs-14">Kit Order#</label>
                                <br />
                                <label className="text-dark fs-15">1321412411</label>
                            </div>
                        </div>
                        <div className="col">
                            <div className="px-2">
                                <label className="label-light-grey fs-14">Kit Part#</label>
                                <br />
                                <label className="text-dark fs-15">1231wd</label>
                            </div>
                        </div>
                        <div className="col">
                            <div className="px-2">
                                <label className="label-light-grey fs-14">Kit Description</label>
                                <br />
                                <label className="text-dark fs-15">Kit-Assembly-Two-Pieces</label>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="col-12 col-md-12 col-lg-12">
                <div className="row">
                    <div className="col-6">
                        <div className="px-2">
                            <label className="fs-14 mt-4">Qty Desired?</label><br />
                            <div className="mt-2">
                                <input
                                    tabIndex={1}
                                    maxLength={10}
                                    type="text"
                                    name="qty_desired"
                                    className="form-control"
                                    placeholder="Enter"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <hr className="mt-5 border-2 border-secondary" />

            <div className="d-flex justify-content-end mt-4 gap-2">
                <FormButton
                    tabIndex={26}
                    className="sph-btn sph-shift"
                    handleClick={() => handleClose()}>
                    Cancel
                </FormButton>
                <FormButton
                    tabIndex={25}
                    className="sph-btn me-2"
                    handleClick={() => handleClose()}>
                    Done
                </FormButton>
            </div>
        </form>

    )
};
export default PrintPackSlipLayout;